// removed by extract-text-webpack-plugin
module.exports = {"column-container-wrapper":"_2LNzzTsYMkUCIEz8HyBgFa","dropdown-title":"_2V_c18twhoY699IRa-C5jr","open":"_3FeN-Kg4W4fKKt6-72Sq57","header-link":"_2V36IEQMbe5YZASIoZLSYC","link-list":"_3FhwT7cB4Rw8scsrK-Fi-i","level-two":"_2CFMayZJoHBfweiBK779h-","dropdown":"_27G54lrJTnhPtQsOuzgrnw","dropdown-header-link":"_3_EWb_EJFQH_1l9YA92Cnr","dropdown-additional-info":"_1P07Go7U47r9Go_zEmPCoS","submenu":"_3XyJlnNIMvfyi7eAzM2lv2","close":"_61NvGFtrvBJQGjHsrtAIU","closeIcon":"_2RB5222t6bQiPaa8x9xHRE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownMenu/DropdownMenu.module.scss
// module id = 754
// module chunks = 0